import React, { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import MobileHeader, {
  GradeButton as MobileGradeButton,
  MyPageButton as MobileMyPageButton,
  NaverGnb as MobileNaverGnb,
} from '@travel-ui/mobile-header';
import PcHeader, {
  GradeButton as PcGradeButton,
  MyPageButton as PcMyPageButton,
  NaverGnb as PcNaverGnb,
  ServiceType,
} from '@travel-ui/pc-header';
import styles from './GlobalHeader.module.scss';
import useUser from '@/hooks/useUser';
import CompareButton from '@/components/CompareButton/CompareButton';
import { env } from '@/lib/env';

const cx = classNames.bind(styles);

const GlobalHeader = () => {
  const [myPageUrl, setMyPageUrl] = useState('');
  const { loading, travelClubUser, me } = useUser();
  const [isMobileWidth, setIsMobileWidth] = useState(false);

  const handleResize = () => {
    if (window?.innerWidth) {
      setIsMobileWidth(window.innerWidth < 768);
    }
  };

  useEffect(() => {
    setMyPageUrl(env('MY_PAGE_URL'));

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className={cx('GlobalHeader')} data-service="pkgtour">
      {!isMobileWidth ? (
        <PcHeader
          service={ServiceType.PKGTOUR}
          subButtons={
            <>
              <div className={cx('options')}>
                <>
                  {!loading && (
                    <>
                      <PcGradeButton travelUser={me?.isLogin ? travelClubUser : undefined} />
                      <CompareButton innerText="상품비교" />
                    </>
                  )}
                </>
              </div>
              <PcMyPageButton url={myPageUrl} />
              <PcNaverGnb />
            </>
          }
        />
      ) : (
        <MobileHeader
          service={ServiceType.PKGTOUR}
          subButtons={
            <>
              <MobileGradeButton travelUser={travelClubUser} />
              <CompareButton />
              <MobileMyPageButton url={myPageUrl} />
              <MobileNaverGnb />
            </>
          }
        />
      )}
    </div>
  );
};

export default GlobalHeader;
